package uz.ferro.erp.feature.user.model

import kotlinx.serialization.Serializable

@Serializable
data class Role(
    val id: Long,
    val name: String
) {

    fun isAdmin() = name == ADMIN

    fun isSuperAdmin() = name == SUPER_ADMIN

    companion object {
        const val SUPER_ADMIN = "SUPERADMIN"
        const val ADMIN ="ADMIN"
        const val USER = "USER"
        const val DISTRIBUTOR = "DISTRIBUTOR"
        const val TASK_MANAGER = "TASK_MANAGER"
        const val SALES_POINT_MANAGER = "SALES_POINT_MANAGER"

        val entries: List<Role> = listOf(
            Role(1, SUPER_ADMIN),
            Role(2, ADMIN),
            Role(3, USER),
            Role(4, DISTRIBUTOR),
            Role(5, TASK_MANAGER),
            Role(6, SALES_POINT_MANAGER)
        )
    }
}